// Constant for Admin

export const ACCESS = {
  SUPER_ADMIN : 'super_admin',
  ADMIN       : 'admin',
  HR          : 'hr',
  VERIFICATOR : 'verificator',
  SALES_LEAD  : 'sales_lead'
}

export const CREATED_AT = {
  ASC: {
    label : 'Oldest',
    value : 'asc'
  },
  DESC: {
    label : 'Newest',
    value : 'desc'
  }
}

export const ACTIVE_STATUS = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}